import React from 'react';

import './App.css';
import { ReactTyped } from "react-typed";
import Particles from 'react-particles';
//import {loadFull} from 'tsparticles';
import { useCallback } from 'react';
import { loadSlim } from "tsparticles-slim";
import pdf from './cv/Thibault_Boisseau_CV.pdf';

function App() {
  const inlogo = require('./image/linkedin_black_logo_icon.png');
  const unrealLogo = require('./image/unreal-engine-logo.png');
  const unityLogo = require('./image/Official_unity_logo.png');
  const androidLogo = require('./image/android_logo.png');
  const itchLogo = require('./image/itch logo.png');
  const reactLogo = require('./image/logo192.png');
  const vueLogo = require('./image/vue-logo.png');
  const strings = ["Thibault Boisseau", "a motivated web developer","a motivated video game developer"];

  const particlesInit = useCallback(async engine => {
      console.log(engine);
      // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
      // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
      // starting from v2 you can add only the features you need reducing the bundle size
      //await loadFull(engine);
      await loadSlim(engine);
    }, []);

    const particlesLoaded = useCallback(async container => {
        await console.log(container);
    }, []);

  return (
    <div className="App">
      
      <header className="App-header">
        <h1>Hello I'm {" "}<ReactTyped strings={strings} typeSpeed={60} backSpeed={50} loop></ReactTyped></h1>
      </header>
      <main>
        <section>
          <h2>About me</h2>
          <div className="container">
          <p>I am a student in software engineering at Télécom Nancy, pursuing a dual degree at the Université du Québec à Chicoutimi to obtain a master's degree in computer science with a specialization in video games. I have a keen interest in RPGs, platformers, and party games, with a particular affection for games in the Mario, Pokémon, and Dragon Quest series. Passionate about video games and new technologies, I am seeking an internship in video game development or web development starting from September 2024.
          </p>
          </div>
        </section>
        <section>
  <h2>My projects</h2>
  <div className="projects">
  <div className="project">
      <h3>Web Development internship</h3>
      <img src={reactLogo} alt="in" className="unreal-logo logo" />
      <p>An application developed during my internship in France where I created a website for a DAX comparison system.</p>
      <a href='/stage2a'>See more</a>
      
    </div>
    <div className="project">
      <h3>Own Pokemon Dex</h3>
      <img src={vueLogo} alt="in" className="unreal-logo logo" />
      <p>An application developed with Vue.js to create my own Pokédex with data about Pokémon and a type table for strategy.</p>
      <a href='https://github.com/Thibault-Boisseau/Own-Pokemon-Dex'>See more</a>
      
    </div>
    <div className="project">
      <h3>Lexicross</h3>
      <img src={reactLogo} alt="in" className="unreal-logo logo" />
      <p>An application to learn English vocabulary by solving random crosswords.</p>
      <a href='https://github.com/Thibault-Boisseau/LexiCross'>See more</a>
      
    </div>
    <div className="project">
      <h3>Khufu's Escape</h3>
      <img src={unrealLogo} alt="in" className="unreal-logo logo" />
      <p>An archaeologist, Khufu, trapped in the pyramid of the (less) famous pharaoh Toutankarthon and cursed to lose his 3D vision, must solve puzzles and avoid traps to escape, while navigating through two different side-scrolling planes to move in a 3D world.</p>
      <a href='/khufu-s-escape'>See more</a>
      
    </div>
    <div className="project">
      <h3>PictureToCard</h3>
      <img src={androidLogo} alt="in" className="unreal-logo logo"/>
      <p>A phone game where users can create their own cards by taking pictures and play a reimagined version of rock-paper-scissors. </p>
      <p></p>
      <a href='https://github.com/ArthurLeo04/PictureToCard/wiki'>See more</a>
    </div>
    <div className="project">
      <h3>Nuit à l'Hôtel</h3>
      <img src={unrealLogo} alt="in" className="unreal-logo logo"/>
      <p>In a chilling, abandoned hotel, the player must navigate through descending floors, solving puzzles and evading a menacing presence while uncovering the grim truth behind the mysterious events unfolding within.</p>
      <a href='/nuit-a-l-hotel'>See more</a>
      
    </div>
    <div className="project">
      <h3>Water drop's journey</h3>
      <img src={unrealLogo} alt="in" className="unreal-logo logo"/>
      <p>In this game, players guide a water droplet through various landscapes, overcoming obstacles and challenges to reach the ocean, all while raising awareness about water pollution and the importance of water conservation.</p>
      <a href='/water-drops-journey'>See more</a>
      
    </div>
    <div className="project">
      <h3>Simon3</h3>
      <img src={unrealLogo} alt="in" className="unreal-logo logo"/>
      <p>A rythme game inspired from the famous games Simon and Osu.</p>
      <a href='/Simon'>See more</a>
      
    </div>
    <div className="project">
      <h3>Projet arcade</h3>
      <img src={unityLogo} alt="in" className="unity-logo logo"/>
      <p><i>Currently in development</i></p>
      <p>A collection of arcade game such as Asteroid or Space Invader.</p>
      <a href='/Arcade'>See more</a>
      
    </div>
    <div className="project">
      <h3>Le Manifeste</h3>
      <img src={unrealLogo} alt="in" className="unreal-logo logo"/>
      <p>Developed for the game jam taking place from May 31st to June 3rd, 2024, with the theme of Restoration.</p>
      <a href='/Manifeste'>See more</a>
      
    </div>
    <div className="project">
      <h3>AR application</h3>
      <img src={unityLogo} alt="in" className="unity-logo logo"/>
      <p>Augmented reality application which allows users to see the different points of disassembly and assembly of an object (use case: PC).</p>
      <a href='/RealAugm'>See more</a>
      
    </div>
  </div>
</section>
        <section id='contact'>
          <h2>Contact me</h2>
          <p>Student⠀<i class="fa-solid fa-envelope"></i> : tboisseau@etu.uqac.ca</p>
          <p>Personnal⠀<i class="fa-solid fa-envelope"></i> : boisseauth@gmail.com</p>
          <p><i class="fa-solid fa-phone"></i> ⠀+1 (438) 409-7028</p>
          <p><i class="fa-solid fa-phone"></i> ⠀+33 6 40 06 29 91</p>
          <div className='redirection'>
          <a href="https://www.linkedin.com/in/thibault-boisseau-10244b267/" className="linkedin-link">
              <img src={inlogo} alt="in" className="linkedin-logo  logo"/>
          </a>
          <a href="https://fafnir66.itch.io/" className="linkedin-link">
              <img src={itchLogo} alt="in" className="linkedin-logo  logo"/>
          </a>
          </div>
          <div className='download'><a href={pdf}>Download my resume</a></div>
          {/* Ajoutez d'autres informations de contact si nécessaire */}
        </section>
      </main>
    
      <div className='particles-container'>
      <Particles 
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
            background: {
                color: {
                    value: "#0d47a1",
                },
            },
            fpsLimit: 120,
            interactivity: {
                events: {
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                    onHover: {
                        enable: true,
                        mode: "repulse",
                    },
                    resize: true,
                },
                modes: {
                    push: {
                        quantity: 4,
                    },
                    repulse: {
                        distance: 200,
                        duration: 0.4,
                    },
                },
            },
            particles: {
                color: {
                    value: "#ffffff",
                },
                links: {
                    color: "#ffffff",
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                },
                move: {
                    direction: "none",
                    enable: true,
                    outModes: {
                        default: "bounce",
                    },
                    random: false,
                    speed: 6,
                    straight: false,
                },
                number: {
                    density: {
                        enable: true,
                        area: 800,
                    },
                    value: 80,
                },
                opacity: {
                    value: 0.5,
                },
                shape: {
                    type: "circle",
                },
                size: {
                    value: { min: 1, max: 5 },
                },
            },
            detectRetina: true,
        }}
      />
      </div>
    </div>
    
  );
}

export default App;
